import { APP_BASE_HREF } from '@angular/common';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { registerLocaleData } from '@angular/common';
import { LOCALE_ID, NgModule, Injector } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { MultiTranslateHttpLoader } from "ngx-translate-multi-http-loader";
import { AuthInterceptor, InterceptorsModule, GuardsModule, MapfreAuditlibModule, ServicesModule, LoadingInterceptor } from 'mapfre-auditlib';
import { ToastModule } from 'primeng/toast';
import { environment } from '../environments/environment';
import { CoreModule } from './@core/core.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MsalModule, MsalInterceptor, MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MsalBroadcastService, MsalGuard, 
  MsalGuardConfiguration, MsalInterceptorConfiguration, MsalService, 
  MsalRedirectComponent} from '@azure/msal-angular';

import localeEs from '@angular/common/locales/es';
import localeEn from '@angular/common/locales/en';
import localePt from '@angular/common/locales/pt';
import localeTr from '@angular/common/locales/tr';
import { InjectorService } from './@core/data/injector/injector.service';
import 'froala-editor/js/languages/es.js';
import 'froala-editor/js/languages/pt_pt.js';
import 'froala-editor/js/languages/pt_br.js';
import 'froala-editor/js/languages/tr.js';
import { LogLevel, IPublicClientApplication, PublicClientApplication, BrowserCacheLocation, InteractionType } from '@azure/msal-browser';

registerLocaleData(localeEs, 'es')
registerLocaleData(localeEn, 'en')
registerLocaleData(localePt, 'pt')
registerLocaleData(localeTr, 'tr')

// MsalInterceptor will obtain tokens and add them to all your Http requests in API calls based on the protectedResourceMap
//lista de direcciones protegidas (con token) de mi API si uso interceptors
export const protectedResourceMap: [string, string[]][] = [
  ['https://graph.microsoft.com/v1.0/me', ['user.read']],
  ["./assets/i18n/*.json", ['null']],
  [environment.base_URL, [environment.scope]],
  [environment.base_URL_GAIA, [environment.scope]],
];
const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;


export function loggerCallback(logLevel: LogLevel, message: string) {
  console.log(message);
}

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.clientId, // application ID
      authority: environment.authority, // tenant ID
      // validateAuthority: true,
      redirectUri: environment.redirectUri,
      postLogoutRedirectUri: environment.redirectUri,
      //navigateToLoginRequestUrl: true,
    },
    cache: {
      cacheLocation: BrowserCacheLocation.SessionStorage,
      storeAuthStateInCookie: isIE, // set to true for IE 11
    },
    system: {
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Warning,
        piiLoggingEnabled: false
      }
    }
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap.set('https://graph.microsoft.com/v1.0/me', ['user.read']);
  protectedResourceMap.set(environment.base_URL, [environment.scope]);
  protectedResourceMap.set(environment.base_URL_GAIA, [environment.scope]);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
    authRequest: {
      extraScopesToConsent: [
            'user.read',
            'openid',
            'profile',
            environment.scope
          ]
    }

    
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return { interactionType: InteractionType.Redirect };
}


// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new MultiTranslateHttpLoader(http, [
    { prefix: `${environment.base_URL}/translations/`, suffix: "" },
    { prefix: "./assets/i18n/", suffix: ".json" },
  ]);
}
@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      },
      useDefaultLang: false
    }),
    HttpClientModule,
    GuardsModule.forRoot(),
    ServicesModule.forRoot(environment),
    ToastModule,
    MapfreAuditlibModule,
    InterceptorsModule,
    CoreModule,
    MsalModule
  ],
  providers: [

    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService,    
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
    { provide: LOCALE_ID, useValue: 'es' },
    { provide: LOCALE_ID, useValue: 'en' },
    { provide: APP_BASE_HREF, useValue: '/' },
  ],
  bootstrap: [AppComponent, MsalRedirectComponent]
})
export class AppModule {
  constructor(private injector: Injector) {
    // Create global Service Injector.
    InjectorService.injector = this.injector;
  }
}


